import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { ApiResponse, ApiPagedResponse, PaginationInfo } from "app/client-core/api-response-models";
import { ApiService } from "../api.service";
import { Router } from '@angular/router';

@Injectable()
export class ClientSettingsService {
    constructor(private apiService: ApiService,
       private router: Router) {
    }

    getClientSettings(params?: any): Observable<ApiResponse<{id, name, value}[]>> {
        return this.apiService.get<{id, name, value}[]>(`clientsettings`, params);
    }
}



// WEBPACK FOOTER //
// ./src/app/client-core/services/client-settings.service.ts